import { InjectionToken } from "@angular/core";

export const SEARCHBAR_STATE_PROP = new InjectionToken<string>("SEARCHBAR_STATE_PROP");
export const searchbarStatePropProvider = {
    provide: SEARCHBAR_STATE_PROP,
    useValue: "searchbars",
};
